module.exports = __webpack_public_path__ + "static/media/gallery12.9a31993c.jpg";